import { Link } from 'react-router-dom';
import { getTranslation } from '../../constants/translations';
import { ROUTES } from '../../constants/routes';
import { scrollTop } from '../../helpers/scrollTop';

import './YourSix.scss';
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from '../Tooltip/Tooltip';
import { getRegion } from '../../helpers/getRegion';

export const YourSix = () => {
  const t = getTranslation();
  const domen = getRegion();
  const data = [
    {
      tooltip: t.yourSix.shop.tooltip,
      text1: t.yourSix.shop.text1,
      your: t.yourSix.shop.your,
      text2: t.yourSix.shop.text2,
      route: ROUTES.SHOP,
      btnText: t.yourSix.shop.title,
      label: 'shop',
    },
    {
      tooltip: t.yourSix.marketing.tooltip,
      text1: t.yourSix.marketing.text1,
      your: t.yourSix.marketing.your,
      text2: t.yourSix.marketing.text2,
      route: ROUTES.MARKETING,
      btnText: t.yourSix.marketing.title,
      label: 'marketing',
    },
    {
      tooltip: t.yourSix.finance.tooltip,
      text1: t.yourSix.finance.text1,
      your: t.yourSix.finance.your,
      text2: t.yourSix.finance.text2,
      route: ROUTES.FINANCE,
      btnText: t.yourSix.finance.title,
      label: 'finance',
    },
    {
      tooltip: t.yourSix.statistics.tooltip,
      text1: t.yourSix.statistics.text1,
      your: t.yourSix.statistics.your,
      text2: t.yourSix.statistics.text2,
      route: ROUTES.STATISTICS,
      btnText: t.yourSix.statistics.title,
      label: 'statistics',
    },
    {
      tooltip: t.yourSix.settings.tooltip,
      text1: t.yourSix.settings.text1,
      your: t.yourSix.settings.your,
      text2: t.yourSix.settings.text2,
      route: ROUTES.SETTINGS,
      btnText: t.yourSix.settings.title,
      label: 'settings',
    },
    {
      tooltip: t.yourSix.dashboard.tooltip,
      text1: t.yourSix.dashboard.text1,
      your: t.yourSix.dashboard.your,
      text2: t.yourSix.dashboard.text2,
      route: ROUTES.DASHBOARD,
      btnText: t.yourSix.dashboard.title,
      label: 'dashboard',
    },
  ];

  return (
    <section className="your-six">
      <div className="_container">
        <div className="your-six__container">
          <h2 className="your-six__title title">{t.yourSix.title}</h2>

          <div className="your-six__cards-list">
            {data.map((card, i) => (
              <article className="your-six__card easy-card" key={card.btnText}>
                <div
                  className={`easy-card__mark your-six__mark your-six__mark--${card.label}`}
                ></div>
                <Tooltip
                  description={card.tooltip}
                  className="your-six__card-text"
                >
                  {domen === 'rs' && i === 5 ? (
                    <strong>{card.text1}</strong>
                  ) : (
                    card.text1
                  )}
                  <p>
                    {domen === 'rs' && i === 5 ? (
                      card.your
                    ) : (
                      <strong>{card.your}</strong>
                    )}
                  </p>
                  {card.text2}
                </Tooltip>
                <Link to={card.route} className="your-six__button button">
                  {card.btnText}
                </Link>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
